export default "__VITE_ASSET__CHZZQHXU__"